import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: false,
})
export class MenuComponent implements OnInit, OnDestroy {
  hideMenu: boolean = false;
  private routerSub?: Subscription;

  constructor(
    private navCtrl: NavController,
    private router: Router
  ) {}

  ngOnInit() {
    // Immer prüfen, ob wir auf der Login-Seite sind
    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.hideMenu = event.url === '/login';
      });

    // Initiale Prüfung (z.B. bei direktem Zugriff auf /login)
    this.hideMenu = this.router.url === '/login';
  }

  ngOnDestroy() {
    this.routerSub?.unsubscribe(); // Speicher freigeben
  }

  navigateTo(page: string) {
    this.navCtrl.navigateForward(page);
  }
}
